// extracted by mini-css-extract-plugin
module.exports = {"locationInfo":"+NonA","locationInfo-title":"pMait","locationInfo-body":"jmeep"};